import { getRoles } from "@testing-library/react";
// import axios from "axios";
import { getToken, getUser, getRole, getFullNameUser } from "../Utils/Common";
import {
    // getAPICall,
    getWithParamsAPICall,
    postAPICall,
    postAPICall2,
    putAPICall,
} from "./axiosMethodCalls";
const user = getUser()
export const getAllOrdersToday = async (status) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            status: status,
        };
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "orders/getAll",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

// GET
export const getAllSingleOrders = async (status) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            status:status
        };
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "order_details/getAll",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
// GET
export const getSingleOrder = async (order_id) => {
    try {
        var payload = {
            requester: user,
            token: getToken(),
        };
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "orders/show/" + order_id,
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

// GET
export const  getGroupOrderID = async (id) => {
    try {
        var payload = {
            requester: user,
            token: getToken(),
        };
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "orders/show/"+id,
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//GET
export const showQR = async (table_no) => {
    try {
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "qrcodes/show/1?table_no=" + table_no
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//POST
export const closeTheTables = async (info) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            table_no: info.table_no,
            reason: info.reason
        };
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "orders/create",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//POST
// export const editSummary = async (info, id) => {
//     try {
//         // var formData = new FormData();
//         // formData.append("requester",getUser()),
//         // formData.append("token",getToken()),
//         // formData.append("phone_no",info.phone_no),
//         // formData.append("pax", info.pax),
//         // formData.append("qr_id", info.qr_id),
//         // formData.append("table_no", info.table_no),
    //         // formData.append("order_no", info.order_no),
    //         // formData.append("menu_ids[]",info.menu_ids),
    //         // formData.append("qty[]",info.qty),
    //         // formData.append("price[]", info.price),
//         // formData.append("remark_2[]",info.remark_2)
        
//         const response = await postAPICall(
//             process.env.REACT_APP_LINK + "orders/update" + id,
//             formData
//         );
//         return { data: response.data };
//     } catch (error) {
//         return { error: error.response };
//     }
// };
export const editSummary = async (info, data, id) => {
    try {
        
        var formData = new FormData();
      
            formData.append("order_no", id)
            info.map((data)=>{
                formData.append("menu_ids[]",data.menu_id)
                formData.append("qty[]",data.qty)
                formData.append("price[]", data.price)
            })
            data.map((infos)=>{
                formData.append("menu_ids[]",infos.id)
                formData.append("qty[]",infos.counter)
                formData.append("price[]", infos.price)
            })
                formData.append("requester", getUser())
                formData.append("token", getToken())
        const response = await postAPICall2(
            process.env.REACT_APP_LINK + "orders/update/" + id,
            formData 
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//POST
export const createOrder = async (orders, info) => {
    try {
        var payload = {
            token: info.token,
            phone_no: info.phone_no,
            pax: info.pax,
            qr_id: info.qr_id,
            table_no: info.table_no,
            // order_no: info.order_no,
            name: "Novel Palconit",
            menu_ids: orders.map((item) => {
                return item.id;
            }),
            qty: orders.map((item) => {
                return item.counter.toString();
            }),
            price: orders.map((item) => {
                return item.price;
            }),
        };
        orders.map((item) => {
            payload[`remark_${item.id}`] = [];
            item.remarks.map((remark) => {
                payload[`remark_${item.id}`].push(remark.split(":")[0]);
            });
        });
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "orders/create",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const createExchangeReturn = async (orders, selected) => {
    try {
        let arr = []
        arr.push(orders.qty)
        let arr_id = []
        arr_id.push(selected.id)
        let arr_price = []
        arr_price.push(selected.price)
        var payload = {
            token: getToken(),
            requester: getUser(), 
            order_detail_ids: [165],
            returned_qty: [2],
            menu_ids: arr_id,
            qty: arr,
            price: arr_price,
            // remark: "desded",
        }
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "orders/exchange",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//POST
export const createOrderTakeout = async (orders, priceType, buzzerNo, type) => {
    try {
        // const storeOrder = orders.map((item) => {
        //     return item.price;
        // })
        // const fdOrder = orders.map((item) => {
        //     return item.foodpanda_price;
        // })
        // const grabOrder = orders.map((item) => {
        //     return item.grab_price;
        // })

        // const modOrder = orders.map((item) => {
        //     return item.with_modifier_total;
        // })
        var payload = {
            token: getToken(),
            name: getFullNameUser(),
            requester: getUser(),
            buzzer_no: buzzerNo.id,
            order_type: type,
            // pricelist: priceType,
            // order_no: priceType.order_no,

            menu_ids: orders.map((item) => {
                return item.id;
            }),
            added_modifiers: orders.map((item) => ({
                [item.id]: item.addons || []
            })),
            qty: orders.map((item) => {
                return item.counter.toString();
            }),
            remarks: orders.map((item) => {
                return item.remarks.toString();
            }),
            // price: priceType === "store" ? storeOrder :  orders.with_modifier === "1" ? modOrder : priceType === "foodpanda" ? fdOrder : grabOrder,
            price: orders.map((item) =>
                item.with_modifier === "1" ?
                item.with_modifier_total : 
                item.pricelist === "store"
                  ? item.price
                  : item.pricelist === "foodpanda"
                  ? item.foodpanda_price
                  : item.grab_price
            ),
            pricelist: orders.map((item) => {
                return item.pricelist;
            }),
        };
        // orders.map((item) => {
        //     payload[`remark_${item.id}`] = [];
        //     item.remarks.map((remark) => {
        //         payload[`remark_${item.id}`].push(remark.split(":")[0]);
        //     });
        // });
   
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "orders/createTakeOut",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//POST
export const additionalOrder = async (orders, order_no, order_id, info) => {
    try {
        var payload = {
            // token: info.token,
            token: getToken(),
            requester: getUser(),
            phone_no: info.phone_no,
            pax: 1,
            qr_id: info.qr_id,
            table_no: info.table_no,
            order_no: order_no,

            menu_ids: orders.map((item) => {
                return item.id;
            }),
            qty: orders.map((item) => {
                return item.counter.toString();
            }),
            price: orders.map((item) => {
                return item.price;
            }),
        };
        orders.map((item) => {
            payload[`remark_${item.id}`] = [];
            item.remarks.map((remark) => {
                payload[`remark_${item.id}`].push(remark.split(":")[0]);
            });
        });
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "orders/additional/" + order_no,
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

// POST
// Only admin can cancel whole order
export const cancelWholeOrder = async (id) => {
    try {
        const response = await putAPICall(
            process.env.REACT_APP_LINK + "orders/mark_cancel/" + id,
            {
                updated_by: getUser(),
                token: getToken(),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

// POST
// Only admin can cancel whole order regardless of status
// Users can only cancel ordered items if status = pending
export const cancelSingleItemOrder = async (order_detail_id) => {
    try {
        // ! once maresolve na ang login API, create a condition
        var payload = {};
        if (getRoles() === "1") {
            // role_id 1 = admin
            payload = {
                updated_by: getUser(),
                token: getToken(),
            };
        } else {
            payload = {
                updated_by: "0",
                token: "getToken()",
            };
        }
        const response = await putAPICall(
            process.env.REACT_APP_LINK +
                "order_details/mark_cancel/" +
                order_detail_id,
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markCancel = async (id, reason) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())
        params.append('reason',reason)

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "order_details/mark_cancel/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markBilled = async (id) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "orders/mark_billed/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markUserBilled = async (id) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',"")
        params.append('token',"")

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "orders/mark_billed/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markPrepare = async (id) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "order_details/mark_preparing/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markComplete = async (id) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "order_details/mark_complete/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markVoid = async (id, user, password, reason) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())
        params.append('reason', reason)
        params.append('authorized_by', user)
        params.append('password', password)

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "order_details/mark_void/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markRefund = async (id, user, password, reason) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by', getUser())
        params.append('token', getToken())
        params.append('reason', reason)
        params.append('authorized_by', user)
        params.append('password', password)

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "order_details/mark_refund/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markRefundGroupOrder = async (id, user, password, reason) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())
        params.append('reason', reason)
        params.append('authorized_by', user)
        params.append('password', password)
        

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "orders/mark_refund/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markVoidGroupOrder = async (id, user, password, reason) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())
        params.append('reason',"")
        params.append('reason', reason)
        params.append('authorized_by', user)
        params.append('password', password)

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "orders/mark_void/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const requestWaiterApi = async (table) => {
    let config = {
        headers: {
            "api-key": "fJcibSRzJQv2NmJmzgnxsgMu56ucqpLBlJIA9FfaQMI9XxQ0Kxm2sEoMQfwisy0b",
        }
    }
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "orders/requestWaiter",{
                table: table,
            }, config
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const addCloseTheTablesApi = async (table, reason, order, authenticateToken, authorizedBy) => {
    let config = {
        headers: {
            "api-key": "fJcibSRzJQv2NmJmzgnxsgMu56ucqpLBlJIA9FfaQMI9XxQ0Kxm2sEoMQfwisy0b",
        }
    }
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "qrcodes/close",{
                table_no: table,
                reason: reason,
                order_id: order,
                authorized_by: authorizedBy,
                authorized_token: authenticateToken,
                requester: getUser(),
                token: getToken(),
            }, config
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


export const markCancelGroupOrder = async (id, reason, authenticateToken, authorizedBy) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())
        params.append('reason',reason)
        params.append('authorized_by',getRole() === "1" ? getUser(): authorizedBy)
        params.append('authorized_token',getRole() === "1" ? getToken() : authenticateToken)

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "orders/mark_cancel/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

